'use client'
import { useEffect, useRef } from 'react'

interface ModalWrapperProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  eyeIconRef?: React.RefObject<HTMLDivElement>
}

export default function ModalWrapper({
  isOpen,
  onClose,
  children,
  eyeIconRef,
}: ModalWrapperProps) {
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleEscape: (event: KeyboardEvent) => void = (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        modalRef.current &&
        !modalRef?.current?.contains(target) &&
        eyeIconRef?.current &&
        !eyeIconRef?.current?.contains(target)
      ) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.removeEventListener('mousedown', handleClickOutside)
      document.body.style.overflow = 'auto'
    }
  }, [isOpen, onClose, eyeIconRef])

  if (!isOpen) return null
  return (
    <div
      ref={modalRef}
      className='absolute top-10 right-1/2 translate-x-1/2 overflow-hidden z-50 shadow-xl'
      role='dialog'
      aria-modal='true'
      aria-labelledby='modal-title'
    >
      {/* Backdrop */}
      {/* <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" /> */}
      <div
        className='bg-white rounded-xl p-6 sm:p-6 md:p-6 
                   w-fit max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl 
                   max-h-[90vh] overflow-y-auto 
                   shadow-xl relative z-50'
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <button
          onClick={onClose}
          className='absolute top-1 md:top-1 right-4 text-black text-xl font-bold focus:outline-none cursor-pointer'
          aria-label='Close modal'
        >
          ×
        </button>
        {children}
      </div>
    </div>
  )
}
